export class FetchUserInfo {
    public static readonly type = '[User] FetchUserInfo';
}
